import React, { ChangeEvent, useState } from "react";
import { warningAlert } from "@hooks/HelperHook";

type Props = {
    url?: string,
    onChange: (file: File) => void
}

function ItemImagePicker({ onChange, url }: Props) {
    const [selectedFile, setSelectedFile] = useState<string | undefined>(undefined);

    const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
        if ((event.target.files?.length || 0) > 0) {
            const file = event.target.files![0];
            const size = file.size / 1024 / 1024;

            if (size < 5) {
                setSelectedFile(URL.createObjectURL(file));
                if (onChange) onChange(file)
            } else {
                warningAlert("File must be under 5Mb")
            }
        }
    };

    const isSelected = () => selectedFile || url

    return <>
        <div className="mb-6">
            <label className="mb-2 block font-display text-jacarta-700 dark:text-white">Image</label>
            <p className="mb-3 text-2xs dark:text-gray-400">Drag or choose your file to upload</p>

            <div className={`group relative flex max-w-md flex-col items-center justify-center rounded-lg border-2 border-dashed border-gray-400 bg-white ${isSelected() ? "py-5 px-2" : "py-20 px-5"} text-center dark:border-gray-400 dark:bg-gray-900`}>

                <div className={`absolute inset-4 cursor-pointer rounded bg-jacarta-50 opacity-0 ${isSelected() ? "" : "group-hover:opacity-100"} dark:bg-jacarta-600`}></div>
                {
                    isSelected() && < img src={selectedFile ?? url} alt="banner" className="h-[18.75rem] object-cover mx-auto" />
                }

                {
                    !isSelected() && <div className="relative z-10 cursor-pointer">
                        <svg xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="24"
                            height="24"
                            className="mb-4 inline-block fill-jacarta-500 dark:fill-white">
                            <path fill="none"
                                d="M0 0h24v24H0z" />
                            <path d="M16 13l6.964 4.062-2.973.85 2.125 3.681-1.732 1-2.125-3.68-2.223 2.15L16 13zm-2-7h2v2h5a1 1 0 0 1 1 1v4h-2v-3H10v10h4v2H9a1 1 0 0 1-1-1v-5H6v-2h2V9a1 1 0 0 1 1-1h5V6zM4 14v2H2v-2h2zm0-4v2H2v-2h2zm0-4v2H2V6h2zm0-4v2H2V2h2zm4 0v2H6V2h2zm4 0v2h-2V2h2zm4 0v2h-2V2h2z" />
                        </svg>
                        <p className="mx-auto max-w-xs text-xs dark:text-white">
                            JPG, JPEG, PNG, GIF, SVG. Max size: 5 MB
                        </p>
                    </div>
                }

                <input onChange={handleFileChange} type="file"
                    accept="image/*"
                    id="file-upload"
                    className="absolute inset-0 z-20 cursor-pointer opacity-0" />
            </div>
        </div>
    </>
}

export default ItemImagePicker;